module.exports = __webpack_public_path__ + "img/banner2.cdb2e4cf.webp";